import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../core';
import './export-form.scss';
import { ExportAttachmentPicker, ExportDatePicker, ExportResourcePicker } from '../';
import { checkFormError } from '../utils/export-form-utils';
import validateExportForm from '../utils/validate-export-form';

const ExportForm = (props) => {
	const { onSubmitHandler = () => {}, isLoading = false, errorMessage = null, clearErrorMessage = () => {} } = props;
	const initialFormData = {
		from: null,
		to: null,
		lines: [],
		attachments: [],
		hasDriveLog: false,
		hasSurvey: false,
		hasObservation: false,
		observationTypes: [],
	};

	const [formData, setFormData] = useState(initialFormData);

	const { t } = useTranslation('exp');

	const formError = validateExportForm(formData);

	//TODO: déplacer cette vérification dans le formulaire
	const resourcesValid =
		formData?.hasDriveLog ||
		formData?.hasSurvey ||
		(formData?.hasObservation && formData?.observationTypes.length > 0);

	const activeBtn = resourcesValid && !checkFormError(formError);

	const handleChange = useCallback((event) => {
		const { name, value } = event.target;
		setFormData((previousForm) => ({ ...previousForm, [name]: value }));
	}, []);

	const handleFormSubmit = (requestData) => (event) => onSubmitHandler(requestData, event);

	const [resetCount, setResetCount] = useState(0);

	const resetForm = () => {
		setFormData(initialFormData);
		setResetCount((prev) => prev + 1);
		clearErrorMessage();
	};



	return (
		<React.Fragment>
			<ExportDatePicker onChange={handleChange} resetKey={resetCount}/>
			<form>
				<ExportAttachmentPicker onChange={handleChange} resetKey={resetCount}/>
				<ExportResourcePicker onChange={handleChange} resetKey={resetCount} lineSelected={formData.lines} />
				{errorMessage && (
						<p className="export-form__error">
							{errorMessage}
						</p>
					)}
				<div className="export-form__button">
					<Button disabled={!activeBtn || isLoading} handleClick={handleFormSubmit(formData)}>
						{t('exp:cta')}
					</Button>
					<Button type="button" className='button--outline' handleClick={resetForm}>
						{'Réinitialiser la sélection'}
					</Button>
				</div>
			</form>
		</React.Fragment>
	);
};

export default ExportForm;
